// extracted by css-extract-rspack-plugin
export default {"sectionLabel":"iQMbCTHdPiE0vpPv"};